import { gql, type TypedDocumentNode } from "@apollo/client";
import type { PaginationVariables } from "@/components/Pagination/Pagination";
import type { CommissionPartnerNode, CommissionPartnerStatus } from "./types";

export interface CommissionPartnersQueryResponse {
  commissionPartners: {
    nodes: CommissionPartnerNode[];
    totalCount: number;
    pageInfo: {
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor?: string;
      endCursor?: string;
    };
  };
}

export interface CommissionPartnersQueryVariables extends PaginationVariables {
  search?: string;
  status?: CommissionPartnerStatus;
}

export const COMMISSION_PARTNERS_QUERY: TypedDocumentNode<
  CommissionPartnersQueryResponse,
  CommissionPartnersQueryVariables
> = gql`
  query CommissionPartners(
    $first: Int
    $after: String
    $last: Int
    $before: String
    $search: String
    $status: BackofficeCommissionPartnerStatus
  ) {
    commissionPartners(first: $first, after: $after, last: $last, before: $before, search: $search, status: $status) {
      nodes {
        id
        name
        legacyId
        status
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;
